import { orchestrator } from 'satcheljs';
import { dismissItem } from '../actions/dismissItem';
import { dismissAllItems } from '../actions/dismissAllItems';
import { markItemsAsDismissed } from '../service/markItemsAsDismissed';

orchestrator(dismissItem, ({ itemId }) => {
    markItemsAsDismissed([itemId]);
});

orchestrator(dismissAllItems, ({ itemIds }) => {
    markItemsAsDismissed(itemIds);
});
